// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_n1-0";